import React from 'react'
import profileImage from '../assets/profile-hero.png'

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center justify-center bg-dark-gradient text-textPrimary overflow-hidden py-20"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Side - Text Content */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            {/* Main Heading - Responsive Text Sizes */}
            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 drop-shadow-lg text-textPrimary">
              Aryan Mehta
            </h1>
            
            {/* Subtitle - Responsive Text Sizes */}
            <h2 className="font-heading text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-6 drop-shadow-md text-primary">
              Full-Stack Developer (MERN & Python)
            </h2>
            
            {/* Description - Responsive Text and Spacing */}
            <p className="font-body text-base sm:text-lg md:text-xl mb-8 max-w-lg mx-auto lg:mx-0 drop-shadow-md text-textSecondary leading-relaxed">
              I build production-style web applications, real-time systems, and automation tools. 
Experience includes authentication systems, REST API architecture, WebSocket communication, and data extraction pipelines.

            </p>
            <p className="font-body text-sm sm:text-base mb-8 text-textSecondary">
              Focused on backend architecture, real-time communication, and practical automation using JavaScript and Python.
            </p>

            
            {/* Buttons - Responsive Layout */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-4 justify-center lg:justify-start items-center">
              <a
                href="#projects"
                className="w-full sm:w-auto bg-primary-gradient text-backgroundDark font-semibold px-6 py-3 rounded shadow-lg hover:opacity-90 transition-all duration-300 font-body text-center"
              >
                View Projects
              </a>
              <a
                href="#hire-me"
                className="w-full sm:w-auto border-2 border-primary text-primary font-semibold px-6 py-3 rounded hover:bg-primary hover:text-backgroundDark transition-all duration-300 font-body text-center"
              >
                Contact Me
              </a>
            </div>
          </div>

          {/* Right Side - Profile Image */}
          <div className="flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative">
              {/* Background Glow Effect */}
              <div className="absolute inset-0 bg-primary/20 rounded-full blur-3xl scale-110"></div>
              
              {/* Profile Image */}
              <div className="relative w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 rounded-full overflow-hidden border-4 border-primary/30 shadow-2xl">
                <img
                  src={profileImage}
                  alt="Aryan Mehta software developer profile"
                  className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-500"
                />
              </div>
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 w-8 h-8 bg-primary rounded-full animate-pulse"></div>
              <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-primary/60 rounded-full animate-pulse delay-1000"></div>
              <div className="absolute top-1/2 -left-8 w-4 h-4 bg-primary/40 rounded-full animate-pulse delay-500"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Down Indicator - Hidden on Small Screens */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 hidden sm:block">
        <div className="animate-bounce">
          <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </section>
  )
}

export default Hero
